import $c from '@/services/api/lib/container'
import { parseHeaders } from '@/store/helpers'
import cloneDeep from 'lodash.clonedeep'

export const actionsMixin = (opts = {}) => {
  return {
    async fetchCollection ({ commit, state, getters }, customOpt = {}) {
      commit('setLoading', true)
      let resource = $c.get(state.model)

      if (state.meta.filters && state.meta.filters.length) {
        resource = resource.loadFilters(state.meta.filters)
      }

      const config = cloneDeep(opts)

      if (opts.http && opts.http.headers) {
        parseHeaders(getters, config.http.headers)
      }

      let includeOpts = []
      if (customOpt.include) {
        includeOpts = [...opts.include, ...customOpt.include]
      }

      let req = resource.page(state.meta.page)
        .include(includeOpts)
        .limit(state.meta.rowsPerPage)
        .orderBy(getters.sort)

      if (customOpt.where && customOpt.where.length) {
        req = req.where(...customOpt.where)
      }

      const res = await req.getFullData(config.http || {})

      commit('setCollection', res.collection)
      commit('setMeta', {
        page: res.page.current_page,
        rowsPerPage: res.page.per_page,
        totalItems: res.page.total
      })
      commit('setLoading', false)
    },

    async fetchSingle ({ commit, state }, id) {
      commit('setLoading', true)
      const resource = await $c.get(state.model).find(id)

      if (opts.singleCallback) await opts.singleCallback(resource)

      commit('setSingle', resource)
      commit('setLoading', false)
    },

    delete ({ commit, state }, items) {
      items.forEach(async (item) => {
        const copy = { ...item }
        copy.delete()
      })
    },

    applyMeta ({ commit, dispatch }, meta, fetchCollection = true) {
      commit('setMeta', meta)
      if (fetchCollection) {
        dispatch('fetchCollection')
      }
    },

    clearFilters ({ dispatch }) {
      dispatch('applyMeta', { filters: [] })
    },

    removeFilter ({ state, dispatch }, idx) {
      let filters = [...state.meta.filters]
      filters.splice(idx, 1)
      dispatch('applyMeta', { filters })
    }
  }
}
